import { jsxs as l, jsx as h } from "react/jsx-runtime";
const o = (v) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...v,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M50.306 13.616c-4.89-4.89-11.391-7.583-18.307-7.583-6.916 0-13.417 2.693-18.307 7.583-4.89 4.89-7.583 11.391-7.583 18.307 0 3.777.796 7.42 2.365 10.825l.535 1.162h5.968v5.122h31.87l-.803-2.998H17.976v-6.015h28.07v6.014l2.997-.803v-1.323h5.945l.535-1.162a25.69 25.69 0 0 0 2.365-10.825c0-6.915-2.693-13.417-7.583-18.307v.002l.001.001Zm2.085 26.298h-3.347v-2.891H17.976a2.997 2.997 0 0 0-2.994 2.891h-3.373a21.724 21.724 0 0 1-1.503-7.991 21.753 21.753 0 0 1 6.413-15.482 21.747 21.747 0 0 1 15.482-6.413 21.749 21.749 0 0 1 15.482 6.413 21.751 21.751 0 0 1 6.413 15.482c0 2.77-.505 5.452-1.503 7.991h-.002Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "m45.14 17.938-3.151.844.844 3.151 3.151-.844-.844-3.151ZM21.187 18.764l-3.151.844.844 3.151 3.151-.844-.844-3.151ZM51.977 30.924h-4.994v1.998h4.994v-1.998ZM32.998 11.945H31v4.994h1.998v-4.994ZM17.016 30.924h-4.994v1.998h4.994v-1.998ZM33.349 28.83h.15v-6.896h-2.997v6.852a3.542 3.542 0 0 0-2.162 3.258 3.54 3.54 0 0 0 3.537 3.537 3.54 3.54 0 0 0 3.537-3.537 3.54 3.54 0 0 0-2.066-3.215l.001.001Zm-1.471 4.755a1.54 1.54 0 0 1 0-3.078 1.54 1.54 0 0 1 0 3.078ZM23.041 41.44h-1.998v3.336h1.998V41.44ZM29.704 41.472h-1.998v3.336h1.998v-3.336ZM36.367 41.472h-1.998v3.336h1.998v-3.336ZM43.028 41.472H41.03v3.336h1.998v-3.336Z"
        }
      )
    ]
  }
);
export {
  o as EstimatedRange
};
